<template>
  <BaseWrapper>
    <PromoActiveList />
  </BaseWrapper>
</template>
<script>
import PromoActiveList from '../../../../components/promo/PromoActiveList.vue';

export default {
  components: { PromoActiveList }
};
</script>
